import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
  Button,
  PageLevelNotification,
  Modal,
  ModalBody,
  ModalFooter,
} from '@americanexpress/dls-react';
import { MODULE_NAME } from '../../constants/modules';

export const getErrorLabelByMessage = (partnerErrorMessage) => {
  switch (partnerErrorMessage) {
    case 'NO_ROOMS_FOUND':
      return 'error.partnerRooms';
    case 'NO_FLIGHTS_FOUND':
      return 'error.partnerFlights';
    case 'NO_CARS_FOUND':
      return 'error.partnerCars';
    default:
      return 'error.genericPartner';
  }
};

const SwitchFlyErrorHandler = ({ location }) => {
  const [errorMessage] = useState(location?.query?.ERROR_MESSAGE);
  const isNotEligibleFHRTHC = errorMessage === 'NOT_ELIGIBLE_FOR_FHR_THC';
  const { formatMessage } = useIntl();
  const [showEligibilityModal, setShowEligibilityModal] = useState(true);
  const toggleEligibilityModal = () => setShowEligibilityModal(!showEligibilityModal);

  if (!errorMessage || (isNotEligibleFHRTHC && !showEligibilityModal)) {
    return null;
  }

  if (isNotEligibleFHRTHC && showEligibilityModal) {
    return (
      <Modal
        id={`${MODULE_NAME}-eligibility-modal`}
        aria-describedby={`${MODULE_NAME}-eligibility-modal-body`}
      >
        <ModalBody
          id={`${MODULE_NAME}-eligibility-modal-body`}
          className="pad-2"
        >
          <FormattedMessage
            id="eligibilityModal.body"
            values={{
              fhr: (
                <span className="font-weight-bold">
                  {formatMessage({ id: 'programName.fhr' })}
                </span>
              ),
              thc: (
                <span className="font-weight-bold">
                  {formatMessage({ id: 'programName.thc' })}
                </span>
              ),
              products: (
                <span className="font-weight-bold">
                  {formatMessage({ id: 'eligibilityModal.body.products' })}
                </span>
              ),
            }}
          />
        </ModalBody>
        <ModalFooter
          id={`${MODULE_NAME}-eligibility-modal-footer`}
          className="flex flex-justify-center"
        >
          <Button
            id={`${MODULE_NAME}-eligibility-modal-button`}
            onClick={toggleEligibilityModal}
            reactlytics={{ element: 'fhr-thc-eligibility-modal-close-button' }}
            variant="primary"
          >
            {formatMessage({ id: 'modal.button.continue' })}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  return (
    <div className="color-surface-bg">
      <PageLevelNotification
        type="critical"
        isIconFilled={true}
        isDismissible={true}
      >
        <div>
          <FormattedMessage id={getErrorLabelByMessage(errorMessage)} />
          <span> </span>
          <FormattedMessage id="error.pleaseAmendYourSearch" />
        </div>
      </PageLevelNotification>
    </div>
  );
};

SwitchFlyErrorHandler.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.shape({
      ERROR_MESSAGE: PropTypes.string,
    }),
  }),
};

SwitchFlyErrorHandler.defaultProps = {
  location: null,
};

export default SwitchFlyErrorHandler;
